import { render, staticRenderFns } from "./PromoBannerHeroes.vue?vue&type=template&id=1e64de34&"
import script from "./PromoBannerHeroes.vue?vue&type=script&lang=js&"
export * from "./PromoBannerHeroes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports